import { jsx as _jsx } from "preact/jsx-runtime";
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { useAppSelector } from '@activitySelector/store/hooks';
import { storeOptions } from '@activitySelector/store';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { getAllActivityLevels } from '@activitySelector/store/reducers/activities';
import { useState } from 'react';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import { useEffect } from 'preact/compat';
import ActivityList from './components/ActivityList';
import Styles from './styles';
function Selector() {
    const activities = useAppSelector(getAllActivityLevels);
    const { currentLevel } = activities;
    const renderLevel = (level) => {
        const options = activities[`level${level}`] ?? null;
        if (currentLevel === level && options) {
            return (_jsx(ActivityList, { label: level === 1 ? 'Choose activity' : undefined, level: level, showBack: level !== 1, presentation: level === 1 ? 'tiles' : 'list', options: activities[`level${level}`] ?? [] }));
        }
        return null;
    };
    return (_jsx(Styles.Wrapper, { children: [1, 2, 3, 4].map(renderLevel) }));
}
function ActivitySelector(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const [refresh, setRefresh] = useState(false);
    const onBookNowClosed = useGlobalEvent('booknow.closed');
    const store = configureStore({
        ...storeOptions,
        preloadedState: { activities: { level1: formattedAttributes.initialLevel, currentLevel: 1 } },
    });
    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                setRefresh(false);
            }, 1);
        }
    }, [refresh]);
    onBookNowClosed(() => {
        setRefresh(true);
    });
    if (refresh) {
        return null;
    }
    return (_jsx(Provider, { store: store, children: _jsx(Selector, {}) }));
}
export default ActivitySelector;
